import { Alert, Button, Group, Stack, Text } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import { useEditVersionContext } from '@/context/EditVersionContext/useEditVersionContext.ts';

export default function StaleDraftNotice() {
  const { staleDraft, reloadEditor } = useEditVersionContext();

  if (!staleDraft) {
    return null;
  }

  const hasLatestDraft = staleDraft.latestVersionId !== null;

  return (
    <Alert
      color="yellow"
      variant="light"
      title="Latest draft changed"
      icon={<IconAlertTriangle size={16} />}
      w="100%"
      radius="md"
    >
      <Stack gap="xs">
        <Text size="sm">
          {hasLatestDraft
            ? 'Another user, agent, or process updated the latest draft while this editor session was open. Reload the editor before retrying step changes so it reflects the current draft.'
            : 'This automation no longer has a latest draft. Reload the editor before retrying step changes so it reflects the current automation state.'}
        </Text>
        <Group>
          <Button size="xs" variant="light" color="yellow" onClick={reloadEditor}>
            Reload editor
          </Button>
        </Group>
      </Stack>
    </Alert>
  );
}
